import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";
import { createAlert } from "@/features/homepage/alertSliceList";

const manageCatalogDataSlice = createSlice({
  name: "manageCatalogData",
  initialState: {
    selectedConnection: -1,
    selectedCatalogType: -1,
    catalogTypes: [],
    connectionsDetail: [],
    appType: -1,
    rows: [],
    selectedRows: [],
    catalogSchema: {},
    qualifiers: [],
    connectionName: "",
    customer: null,
    isEdiHandlingConnection: false,
    status: "initial",
    error: null,
    addEditInfo: {
      customers: [],
      items: [],
      isOpen: false,
      isEdit: false,
      connectionInfo: { connectionDisplayName: "", connectionId: -1 },
      catalogType: -1,
      catalogId: null,
      catalogData: {},
    },
  },
  reducers: {
    setConnection: (state, action) => {
      const { selectedConnection } = action.payload;
      state.selectedConnection = selectedConnection;
    },
    setConnectionsDetail: (state, action) => {
      const { connectionsDetail } = action.payload;
      state.connectionsDetail = connectionsDetail;
    },
    setCatalogTypes: (state, action) => {
      const { catalogTypes } = action.payload;
      state.catalogTypes = catalogTypes;
    },
    setCatalogType: (state, action) => {
      const { catalogType } = action.payload;
      state.selectedCatalogType = catalogType;
    },
    setAppType: (state, action) => {
      const { appType } = action.payload;
      state.appType = appType;
    },
    setRowsData: (state, action) => {
      const { rows } = action.payload;
      state.rows = rows;
    },
    setSelectedRow: (state, action) => {
      const { rows } = action.payload;
      state.selectedRows = rows;
    },
    setCatalogSchema: (state, action) => {
      const { schema } = action.payload;
      state.catalogSchema = schema;
    },
    setConnectionName: (state, action) => {
      const { connectionName, displayName } = action.payload;
      state.connectionName = connectionName;
      state.displayName = displayName;
    },
    setCustomer: (state, action) => {
      const { customer } = action.payload;
      state.customer = customer;
    },
    setIsAddCatalogOpen: (state, action) => {
      const { isOpen, isEdit, connectionInfo, catalogType } = action.payload;
      state.addEditInfo.isOpen = isOpen;
      state.addEditInfo.isEdit = isEdit;
      state.addEditInfo.connectionInfo = connectionInfo;
      state.addEditInfo.catalogType = catalogType;
    },
    setIsEdit: (state, action) => {
      const { isEdit } = action.payload;
      state.addEditInfo.isEdit = isEdit;
    },
    setCatalogIdToEdit: (state, action) => {
      const { catalogId } = action.payload;
      state.addEditInfo.catalogId = catalogId;
    },
    setCatalogData: (state, action) => {
      const { data } = action.payload;
      state.addEditInfo.catalogData = data;
    },
    setCatalogDataField: (state, action) => {
      const { name, value } = action.payload;
      const newData = { ...state.addEditInfo.catalogData, [name]: value };
      state.addEditInfo.catalogData = newData;
    },
    resetCatalogData: (state, action) => {
      state.addEditInfo.catalogData = { ItemQualifiers: {} };
    },
    resetAddEditPopUp: (state, action) => {
      state.addEditInfo.isOpen = false;
      state.addEditInfo.isEdit = false;
      state.addEditInfo.connectionInfo = {
        connectionDisplayName: "",
        connectionId: -1,
      };
      state.addEditInfo.catalogType = -1;
      state.addEditInfo.catalogId = null;
      state.addEditInfo.catalogData = { ItemQualifiers: {} };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalogTypes.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCatalogTypes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCatalogTypes.fulfilled, (state, action) => {
        state.status = "loaded";
        state.catalogTypes = action.payload.data;
      })
      .addCase(fetchCatalogDetails.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCatalogDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCatalogDetails.fulfilled, (state, action) => {
        state.status = "loaded";
        state.rows = action.payload;
      })
      .addCase(fetchCatalogTypeSchema.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCatalogTypeSchema.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCatalogTypeSchema.fulfilled, (state, action) => {
        state.status = "loaded";
        state.catalogSchema = action.payload.data;
      })
      .addCase(updateCatalogData.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateCatalogData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateCatalogData.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.catalogSchema = action.payload.data;
      })
      .addCase(deleteCatalogData.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(deleteCatalogData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteCatalogData.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.catalogSchema = action.payload.data;
      })
      .addCase(fetchCustomerCodes.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCustomerCodes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCustomerCodes.fulfilled, (state, action) => {
        state.status = "loaded";
        state.addEditInfo.customers = action.payload.data;
      })
      .addCase(fetchItemCodes.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchItemCodes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchItemCodes.fulfilled, (state, action) => {
        state.status = "loaded";
        state.addEditInfo.items = action.payload.data;
      })
      .addCase(fetchAppType.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchAppType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchAppType.fulfilled, (state, action) => {
        state.status = "loaded";
        state.appType = action.payload;
      })
      .addCase(fetchItemQualifiers.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchItemQualifiers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchItemQualifiers.fulfilled, (state, action) => {
        state.status = "loaded";
        state.qualifiers = action.payload;
      })
      .addCase(checkIfHandlingEdi.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(checkIfHandlingEdi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(checkIfHandlingEdi.fulfilled, (state, action) => {
        state.status = "loaded";
        state.isEdiHandlingConnection = action.payload;
      });
  },
});

export const fetchCatalogTypes = createAsyncThunk(
  "manageCatalogData/fetchCatalogTypes",
  async () => {
    const response = await axios.get(
      "/connectioncatalogartifacts/get-catalog-types",
    );
    return response;
  },
);
export const fetchCatalogDetails = createAsyncThunk(
  "manageCatalogData/fetchCatalogDetails",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios
      .get("/connectioncatalogartifacts", {
        params: {
          connectionId: state.tempInfo.manageCatalogData.selectedConnection,
          catalogType: state.tempInfo.manageCatalogData.selectedCatalogType,
        },
      })
      .then((response) => {
        if (response.data) {
          const r = response.data.map((row) => {
            if (row.ArtifactData !== "") {
              const property = JSON.parse(row.ArtifactData);
              const objectMap = (obj) =>
                Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v]));

              // If the object has nested objects, then have to flatten it to simple object
              // So, it can be used to display in the datagrid
              function flattenObj(obj, parent, res = {}) {
                for (let key in obj) {
                  let propName = key;
                  if (typeof obj[key] == "object") {
                    flattenObj(obj[key], propName, res);
                  } else {
                    res[propName] = obj[key];
                  }
                }
                return res;
              }
              return {
                id: row.ArtifactDictionaryDataId,
                ...objectMap(flattenObj(property)),
              };
            }
          });
          return r;
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
    return response;
  },
);
export const fetchCatalogTypeSchema = createAsyncThunk(
  "manageCatalogData/fetchCatalogTypeSchema",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios.get("/connectioncatalogartifacts/schema", {
      params: {
        catalogType: state.tempInfo.manageCatalogData.selectedCatalogType,
      },
    });
    return response;
  },
);

export const updateCatalogData = createAsyncThunk(
  "manageCatalogData/updateCatalogData",
  async ({
    validateForm,
    handleClose,
    dispatch,
    selectedConnection,
    catalogData,
    selectedCatalogType,
    artifactId,
    itemQualifiers, //optional parameter, used for item catalog
  }) => {
    const validation = validateForm();

    if (!validation.isValid) {
      dispatch(
        createAlert({
          status: "Error",
          message: validation.message,
        }),
      );
      return;
    }

    try {
      const response = await axios.put(
        "/connectioncatalogartifacts/update-catalog-data",
        {
          connectionId: selectedConnection,
          catalogType: selectedCatalogType,
          jsonData: catalogData,
          itemQualifiers: itemQualifiers ? itemQualifiers : undefined,
          catalogId: artifactId,
        },
      );
      if (response.data.error === true) {
        dispatch(
          createAlert({
            status: "Error",
            message: response.data.message,
          }),
        );
      } else {
        dispatch(
          createAlert({
            status: "Success",
            message: "Catalog updated successfully",
          }),
        );
      }
      handleClose();
      return response;
    } catch (e) {
      dispatch(
        createAlert({
          status: "Error",
          message: "Error updating catalog",
        }),
      );
      handleClose();
    }
  },
);

export const deleteCatalogData = createAsyncThunk(
  "manageCatalogData/deleteCatalogData",
  async ({ selectedMappings }) => {
    const response = await axios.delete(
      "/connectioncatalogartifacts/catalog-data",
      {
        headers: {
          "Content-Type": "application/json",
        },
        data: selectedMappings,
      },
    );
    return response;
  },
);

export const fetchCustomerCodes = createAsyncThunk(
  "manageCatalogData/fetchCustomerCodes",
  async ({ selectedConnectionId }) => {
    const response = await axios.get(
      "/connectioncatalogartifacts/get-customer-codes",
      {
        params: {
          connectionId: selectedConnectionId,
        },
      },
    );
    return response;
  },
);

export const fetchItemCodes = createAsyncThunk(
  "manageCatalogData/fetchItemCodes",
  async ({ selectedConnectionId }) => {
    const response = await axios.get(
      "/connectioncatalogartifacts/item-uom-codes",
      {
        params: {
          connectionId: selectedConnectionId,
        },
      },
    );
    return response;
  },
);

export const fetchAppType = createAsyncThunk(
  "manageCatalogData/fetchAppType",
  async (connectionId) => {
    const response = await axios.get("/connections/app-type", {
      params: {
        connectionId: connectionId,
      },
    });
    const appType = response.data;
    return appType;
  },
);

export const fetchItemQualifiers = createAsyncThunk(
  "manageCatalogData/fetchItemQualifiers",
  async ({ connectionId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "/connectionartifactschema/item-qualifiers",
        {
          params: { connectionId, artifactType: -1 },
        },
      );

      return response.data.values;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const checkIfHandlingEdi = createAsyncThunk(
  "manageCatalogData/checkIfHandlingEdi",
  async ({ connectionId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "/connectioncatalogartifacts/check-if-edi",
        {
          params: { connectionId },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const handleAddCatalog = async (
  validateForm,
  handleClose,
  dispatch,
  selectedConnection,
  selectedCatalogType,
  catalogData,
  itemQualifiers, //optional parameter, used for item catalog
) => {
  const validation = validateForm();

  if (!validation.isValid) {
    dispatch(
      createAlert({
        status: "Error",
        message: validation.message,
      }),
    );
    return;
  }

  try {
    const response = await axios.post(
      "/connectioncatalogartifacts/add-catalog-data",
      {
        connectionId: selectedConnection,
        catalogType: selectedCatalogType,
        jsonData: catalogData,
        itemQualifiers: itemQualifiers ? itemQualifiers : undefined,
      },
    );
    if (response.data.error === true) {
      dispatch(
        createAlert({
          status: "Error",
          message: response.data.message,
        }),
      );
    } else {
      dispatch(
        createAlert({
          status: "Success",
          message: "Catalog added successfully",
        }),
      );
    }
    handleClose();
  } catch (e) {
    dispatch(
      createAlert({
        status: "Error",
        message: "Error adding catalog",
      }),
    );
    handleClose();
  }
};

export const selectAppType = (state) =>
  state.tempInfo.manageCatalogData.appType;
export const selectConnection = (state) =>
  state.tempInfo.manageCatalogData.selectedConnection;
export const selectConnectionsDetail = (state) =>
  state.tempInfo.manageCatalogData.connectionsDetail;
export const selectCatalogTypes = (state) =>
  state.tempInfo.manageCatalogData.catalogTypes;
export const selectCatalogType = (state) =>
  state.tempInfo.manageCatalogData.selectedCatalogType;
export const selectRows = (state) => state.tempInfo.manageCatalogData.rows;
export const selectCatalogSchema = (state) =>
  state.tempInfo.manageCatalogData.catalogSchema;
export const selectSelectedRows = (state) =>
  state.tempInfo.manageCatalogData.selectedRows;
export const selectConnectionName = (state) =>
  state.tempInfo.manageCatalogData.connectionName;
export const selectConnectionDisplayName = (state) =>
  state.tempInfo.manageCatalogData.displayName;
export const selectEditCatalogData = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.catalogData;
export const selectEditCatalogId = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.catalogId;
export const selectIsEditMode = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.isEdit;
export const selectIsAddEditOpen = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.isOpen;
export const selectAddEditConnectionInfo = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.connectionInfo;
export const selectAvailableItems = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.items;
export const selectAvailableCustomers = (state) =>
  state.tempInfo.manageCatalogData.addEditInfo.customers;

export const {
  setConnection,
  setConnectionsDetail,
  setCatalogTypes,
  setCatalogType,
  setAppType,
  setRowsData,
  setSelectedRow,
  setCatalogSchema,
  setConnectionName,
  setCustomer,
  setIsAddCatalogOpen,
  setCatalogData,
  resetCatalogData,
  setCatalogDataField,
  resetAddEditPopUp,
  setCatalogIdToEdit,
  setIsEdit,
} = manageCatalogDataSlice.actions;

export default manageCatalogDataSlice.reducer;
